import React from 'react';

type NoReviewsIllustrationProps = {
  width?: number;
  height?: number;
};

const NoReviewsIllustration = ({ width = 240, height = 200 }: NoReviewsIllustrationProps) => {
  return (
    <svg
      width={width}
      height={height}
      data-testid="noReviews-illustration"
      viewBox="0 0 240 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="120" cy="91" r="84" fill="#D7F1FF" />
      <mask
        id="mask0_26570_10091"
        fill="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="36"
        y="7"
        width="168"
        height="168"
      >
        <circle cx="120" cy="91" r="84" fill="#D7F1FF" />
      </mask>
      <g mask="url(#mask0_26570_10091)">
        <ellipse cx="69.5898" cy="87.858" rx="11.9101" ry="11.2331" fill="white" />
        <ellipse cx="54.5" cy="92" rx="12.5" ry="11" fill="white" />
        <ellipse cx="53.3687" cy="81.1186" rx="11.4791" ry="9.1186" fill="white" />
        <path
          d="M50 88C50 93.5228 45.7467 98 40.5 98C35.2533 98 31 93.5228 31 88C31 82.4771 35.2533 78 40.5 78C45.7467 78 50 82.4771 50 88Z"
          fill="white"
        />
        <ellipse
          cx="9.66308"
          cy="9.43052"
          rx="9.66308"
          ry="9.43052"
          transform="matrix(-0.998852 0.0469061 0.0770992 0.996919 190.805 95.9492)"
          fill="white"
        />
        <ellipse
          cx="10.2333"
          cy="8.89133"
          rx="10.2333"
          ry="8.89133"
          transform="matrix(-0.998852 0.0469081 0.0771048 0.996918 205.233 100.266)"
          fill="white"
        />
        <ellipse
          cx="9.34868"
          cy="8.14599"
          rx="9.34868"
          ry="8.14599"
          transform="matrix(-0.998852 0.0469078 0.077105 0.996918 203.86 90.332)"
          fill="white"
        />
        <ellipse
          cx="7.61645"
          cy="7.65223"
          rx="7.61645"
          ry="7.65223"
          transform="matrix(-0.998852 0.0469078 0.077093 0.996919 214.309 96.1699)"
          fill="white"
        />
        <circle
          cx="4.58333"
          cy="4.58333"
          r="4.58333"
          transform="matrix(-1 0 0 1 79.167 37.833)"
          fill="white"
        />
        <ellipse
          cx="5.5"
          cy="4.58333"
          rx="5.5"
          ry="4.58333"
          transform="matrix(-1 0 0 1 86.5 39.667)"
          fill="white"
        />
        <ellipse
          cx="5.04167"
          cy="4.125"
          rx="5.04167"
          ry="4.125"
          transform="matrix(-1 0 0 1 86.5 36)"
          fill="white"
        />
        <circle
          cx="3.66667"
          cy="3.66667"
          r="3.66667"
          transform="matrix(-1 0 0 1 92 38.75)"
          fill="white"
        />
        <circle cx="170.429" cy="63.9999" r="6.42857" fill="white" />
        <ellipse cx="161.428" cy="66.5712" rx="7.71429" ry="6.42857" fill="white" />
        <ellipse cx="160.785" cy="60.7857" rx="7.07143" ry="5.78571" fill="white" />
        <circle cx="151.143" cy="64.0003" r="5.14286" fill="white" />
      </g>
      <path
        d="M124.977 34.9208C125.804 36.5379 126.918 37.05 126.9 38.0652L129.568 38.0922C129.577 37.3195 132.021 36.6727 131.751 31.5428C131.661 29.6023 131.679 26.7724 130.215 27.1317C129.883 27.2305 129.865 27.6708 129.865 27.6708C129.82 27.5719 129.685 27.0958 129.11 27.2126C128.733 27.2934 128.67 27.554 128.67 27.7876C128.643 27.6169 128.373 27.3024 127.888 27.3923C127.403 27.4821 127.349 27.8774 127.349 28.0481C126.9 27.7516 126.154 27.8235 126.001 28.65C125.849 29.4765 126.019 30.7882 125.992 31.6147C125.921 31.1206 125.885 30.6265 125.876 30.1324C125.849 28.9914 124.483 29.0273 124.393 29.8539C124.375 30.4648 124.088 33.0701 124.977 34.9118V34.9208Z"
        fill="#EFCDAB"
      />
      <path
        d="M129.601 38.0829C129.772 37.3462 129.305 36.6185 128.559 36.4478C127.814 36.2771 127.068 36.7353 126.906 37.472C126.736 38.2086 127.203 38.9363 127.948 39.107C128.694 39.2777 129.44 38.8196 129.601 38.0829Z"
        fill="#F9D7B5"
      />
      <path
        d="M130.276 64.2089L123.709 63.8945L126.925 37.6973L129.647 37.823L130.276 64.2089Z"
        fill="#EFCDAB"
      />
      <path
        d="M126.718 39.0088C125.766 38.7033 123.538 60.4894 123.376 64.1638C123.457 64.7568 129.665 75.304 130.392 64.64C130.842 58.0098 130.698 39.7005 130.051 39.1525C129.395 38.6135 127.679 39.3232 126.727 39.0177L126.718 39.0088Z"
        fill="#005300"
      />
      <path
        d="M109.225 191.322C130.301 197.386 152.294 185.213 158.358 164.146C164.422 143.078 152.249 121.077 131.182 115.012C110.105 108.948 88.1127 121.121 82.0485 142.189C75.9843 163.256 88.1576 185.258 109.225 191.322Z"
        fill="#4DC4FF"
      />
      <path
        d="M156.048 136.179L154.08 134.723C154.08 134.723 150.765 132.783 147.791 134.499C144.827 136.187 145.986 137.921 143.533 140.23C141.116 142.557 142.644 145.755 140.119 147.355C137.595 148.954 130.345 151.281 132.007 158.117C133.803 165.565 142.904 161.765 146.183 165.053C149.732 168.62 145.033 172.573 143.497 174.612C141.961 176.651 140.757 181.386 142.006 183.434C142.482 184.207 143.874 183.56 145.069 184.063C151.223 179.131 155.985 172.303 158.33 164.137C161.115 154.452 160.01 144.596 156.012 136.17H156.039L156.048 136.179Z"
        fill="#009500"
      />
      <path
        d="M87.6088 141.659C91.1844 142.593 91.2204 147.112 92.9004 148.999C94.5804 150.886 99.9348 150.517 99.8809 154.219C99.827 157.92 97.7876 156.95 96.4939 160.013C95.1104 164.155 100.6 167.165 101.417 170.291C102.81 175.717 97.6888 179.266 97.2756 182.159C96.8533 185.061 99.4048 186.013 100.519 186.013C101.633 186.013 103.834 183.219 106.691 183.434C109.548 183.65 112.297 183.713 113.572 181.063C114.713 178.655 114.597 177.828 116.016 176.652C117.148 175.708 119.304 176.166 120.67 175.699C122.565 175.07 124.299 174.459 126.437 172.115C128.576 169.77 129.708 165.269 127.255 162.529C124.793 159.816 120.625 161.702 118.262 159.214C115.899 156.725 116.78 155.072 113.644 153.275C110.545 151.461 113.842 148.945 109.871 146.726C106.861 145.037 104.22 147.355 101.669 145.289C100.114 144.049 99.4587 141.821 100.896 140.24C104.292 137.275 108.353 141.812 112.225 138.317C114.884 135.909 115.028 134.104 118.433 132.765C121.838 131.426 123.661 135.352 127.498 133.052C130.372 131.336 127.075 128.102 129.69 125.425C131.001 124.086 132.088 122.047 131.468 119.451C131.181 118.229 131.271 116.279 131.594 115.165C112.333 109.335 92.1457 118.948 84.0781 136.736C84.6351 138.901 85.5425 141.129 87.5908 141.65L87.6088 141.659Z"
        fill="#009500"
      />
      <path
        d="M158.169 114.842L156.507 121.724C148.43 121.993 140.345 121.382 132.403 119.891L116.492 116.926L120.391 100.827L158.178 114.842H158.169Z"
        fill="#F9D7B5"
      />
      <path
        d="M157.336 121.814C159.285 121.814 160.875 120.233 160.875 118.274C160.875 116.316 159.294 114.734 157.336 114.734C155.377 114.734 153.796 116.316 153.796 118.274C153.796 120.233 155.377 121.814 157.336 121.814Z"
        fill="#F9D7B5"
      />
      <path
        d="M118.434 117.16C123.006 117.16 126.717 113.45 126.717 108.877C126.717 104.304 123.006 100.594 118.434 100.594C113.861 100.594 110.15 104.304 110.15 108.877C110.15 113.45 113.861 117.16 118.434 117.16Z"
        fill="#F9D7B5"
      />
      <path
        d="M160.749 117.321L153.93 119.235C155.062 127.006 157.047 134.633 159.841 141.973L165.744 157.489L170.568 156.132L160.758 117.321H160.749Z"
        fill="#EFCDAB"
      />
      <path
        d="M168.152 159.313C169.536 159.313 170.659 158.19 170.659 156.806C170.659 155.423 169.536 154.3 168.152 154.3C166.769 154.3 165.646 155.423 165.646 156.806C165.646 158.19 166.769 159.313 168.152 159.313Z"
        fill="#EFCDAB"
      />
      <path
        d="M170.559 156.132C172.49 160.48 176.228 160.777 182.229 161.495C182.948 161.585 183.577 161.909 183.711 162.583C183.846 163.256 183.379 163.795 182.705 163.93L168.726 166.688C167.531 166.922 166.363 166.149 166.13 164.954C165.851 163.526 166.345 159.636 165.726 157.48L170.55 156.123L170.559 156.132Z"
        fill="#EFCDAB"
      />
      <path
        d="M165.916 158.585C165.395 158.63 165.035 159.519 165.215 160.193C165.098 161.164 165.107 162.466 165.152 162.969C165.242 163.976 165.709 166.32 166.284 166.949C166.643 167.344 167.838 167.533 170.722 167.264C171.27 167.21 171.845 166.743 172.07 166.419C175.286 167.901 182.257 166.239 184.171 164.586C185.582 163.374 185.123 161.244 181.907 161.074C179.032 160.912 173.777 160.66 172.393 157.902C172.16 157.435 172.016 157.238 171.342 157.3C170.992 157.336 170.48 157.947 170.435 158.414C170.345 159.196 170.947 160.032 171.324 160.544C170.623 160.633 168.728 160.589 167.506 159.978C166.697 159.573 166.275 158.54 165.925 158.576L165.916 158.585Z"
        fill="#4D4D4D"
      />
      <path
        d="M172.23 160.687C172.769 161.487 174.315 159.115 174.315 159.115C174.315 159.115 171.691 159.888 172.23 160.687Z"
        stroke="#686868"
        strokeWidth="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M173.955 161.289C173.955 161.289 174.557 160.202 175.24 159.852"
        stroke="#686868"
        strokeWidth="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M175.202 161.451C175.202 161.451 175.723 160.427 176.289 160.112"
        stroke="#686868"
        strokeWidth="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M176.463 161.613C176.463 161.613 176.903 160.652 177.352 160.373"
        stroke="#686868"
        strokeWidth="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M177.719 161.775C177.719 161.775 178.069 160.876 178.411 160.634"
        stroke="#686868"
        strokeWidth="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M127.195 102.678C118.867 100.881 105.678 114.384 116.262 117.537C127.141 120.78 145.675 124.733 154.066 124.886C155.917 133.555 162.583 158.055 164.191 157.74C166.5 157.291 168.458 156.105 171.279 154.65C171.908 154.326 163.158 119.109 160.867 115.947C157.785 111.688 137.329 104.852 127.186 102.669L127.195 102.678Z"
        fill="#D1D1D1"
      />
      <path
        d="M157.677 117.501L155.557 124.257C147.48 123.979 139.457 122.829 131.623 120.816L115.946 116.782L120.914 100.971L157.668 117.501H157.677Z"
        fill="#EFCDAB"
      />
      <path
        d="M156.616 124.419C158.574 124.419 160.156 122.838 160.156 120.88C160.156 118.921 158.574 117.34 156.616 117.34C154.657 117.34 153.076 118.921 153.076 120.88C153.076 122.838 154.657 124.419 156.616 124.419Z"
        fill="#EFCDAB"
      />
      <path
        d="M118.434 117.16C123.006 117.16 126.717 113.45 126.717 108.877C126.717 104.304 123.006 100.594 118.434 100.594C113.861 100.594 110.15 104.304 110.15 108.877C110.15 113.45 113.861 117.16 118.434 117.16Z"
        fill="#EFCDAB"
      />
      <path
        d="M160.146 121.131L153.085 120.619C151.522 128.318 150.803 136.152 150.938 144.004L151.234 160.607L156.229 160.966L160.137 121.122H160.146V121.131Z"
        fill="#F9D7B5"
      />
      <path
        d="M153.731 163.301C155.115 163.301 156.238 162.178 156.238 160.795C156.238 159.411 155.115 158.288 153.731 158.288C152.348 158.288 151.225 159.411 151.225 160.795C151.225 162.178 152.348 163.301 153.731 163.301Z"
        fill="#F9D7B5"
      />
      <path
        d="M156.236 160.974C156.03 163.059 160.719 164.981 166.469 166.85C167.152 167.074 167.718 167.524 167.718 168.206C167.718 168.889 167.161 169.338 166.469 169.338H152.23C151.008 169.338 150.02 168.35 150.02 167.128C150.02 165.673 151.241 166.616 151.241 160.624L156.236 160.983V160.974Z"
        fill="#F9D7B5"
      />
      <path
        d="M151.242 160.822C150.721 160.768 150.191 161.567 150.245 162.268C149.949 163.202 149.697 164.478 149.643 164.981C149.535 165.979 149.544 168.377 149.985 169.096C150.263 169.554 151.404 169.967 154.279 170.273C154.827 170.327 155.483 169.985 155.761 169.707C158.636 171.782 165.787 171.513 167.988 170.255C169.606 169.33 169.57 167.164 166.452 166.365C163.658 165.655 158.555 164.388 157.738 161.415C157.603 160.903 157.504 160.687 156.821 160.615C156.471 160.579 155.851 161.082 155.716 161.531C155.483 162.286 155.905 163.22 156.175 163.795C155.474 163.75 153.623 163.337 152.536 162.502C151.817 161.954 151.602 160.858 151.26 160.822H151.242Z"
        fill="#686868"
      />
      <path
        d="M157.02 164.11C157.397 164.999 159.373 162.969 159.373 162.969C159.373 162.969 156.651 163.22 157.02 164.11Z"
        stroke="#828282"
        strokeWidth="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M158.601 165.035C158.601 165.035 159.4 164.092 160.137 163.876"
        stroke="#828282"
        strokeWidth="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M159.805 165.439C159.805 165.439 160.514 164.541 161.134 164.334"
        stroke="#828282"
        strokeWidth="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M161 165.844C161 165.844 161.611 164.99 162.114 164.802"
        stroke="#828282"
        strokeWidth="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M162.202 166.248C162.202 166.248 162.723 165.439 163.101 165.26"
        stroke="#828282"
        strokeWidth="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M125.503 88.8516H111.345C111.345 88.8516 107.661 103.19 107.005 106.388C105.784 112.318 108.443 115.705 115.45 117.87C128.36 121.85 140.848 125.479 149.527 126.521C149.221 137.967 148.287 159.394 149.589 158.72C151.817 157.561 158.178 159.672 158.6 157.866C159.112 155.674 162.445 121.113 160.46 118.903C155.914 113.854 138.665 106.442 127.282 102.256C126.788 96.2723 125.512 88.8605 125.512 88.8605L125.503 88.8516Z"
        fill="#EBEBEB"
      />
      <path
        d="M120.868 37.5263H120.859C120.958 37.0861 121.038 36.6459 121.074 36.1787C121.479 31.0668 117.651 26.5928 112.531 26.1885C107.41 25.7843 102.927 29.6024 102.522 34.7143C102.118 39.8262 105.945 44.3002 111.066 44.7045L118.325 45.2705C120.14 45.4142 121.721 44.0576 121.865 42.2519L122.125 38.9727C121.371 38.9098 120.814 38.254 120.877 37.5083L120.868 37.5263Z"
        fill="#F9D7B5"
      />
      <path
        d="M111.265 40.3288C111.795 40.2749 112.181 39.8077 112.128 39.2776C112.074 38.7476 111.607 38.3613 111.076 38.4152C110.546 38.4691 110.16 38.9362 110.214 39.4663C110.268 39.9964 110.735 40.3827 111.265 40.3288Z"
        fill="#EFCDAB"
      />
      <path
        d="M121.613 30.4644C120.832 26.2599 115.684 23.3221 111.641 23.1784C107.536 23.0346 102.927 24.9662 101.202 28.7844C99.7554 31.9827 99.7554 36.1871 101.57 39.089C104.76 44.1829 109.871 44.5153 109.862 44.5332L110.204 39.3675C110.896 39.1339 109.898 35.9715 110.869 36.0254C112.782 36.1243 115.289 35.9805 117.077 35.5223C118.64 35.127 120.41 34.3095 121.263 32.7822C121.362 32.6025 121.443 32.4229 121.506 32.2342C121.694 31.6682 121.721 31.0663 121.613 30.4733V30.4644Z"
        fill="#333333"
      />
      <path
        d="M118.516 25.7843C119.944 27.1049 121.957 28.4076 123.43 28.2638C123.547 28.2548 123.61 28.3896 123.529 28.4705C122.927 29.0544 121.175 30.3301 117.815 29.7013C113.844 28.9646 117.752 26.1885 118.372 25.7663C118.417 25.7393 118.48 25.7393 118.516 25.7753"
        fill="#4D4D4D"
      />
      <path
        d="M111.175 39.3681C109.917 39.6466 108.678 38.8471 108.399 37.5983C108.121 36.3406 108.92 35.1008 110.169 34.8312L110.726 34.7773"
        fill="#EFCDAB"
      />
      <path
        d="M112.998 27.9493C107.653 30.7792 111.103 38.4425 111.704 37.7418C112.306 37.05 112.315 33.16 116.277 30.7972C117.337 30.1683 119.601 30.3929 119.601 30.3929C118.299 26.8712 115.972 26.3861 112.998 27.9583V27.9493Z"
        fill="#4D4D4D"
      />
      <path
        d="M115.003 47.1302L112.668 38.0295C112.614 37.4994 112.128 37.1221 111.598 37.176C111.068 37.2299 110.682 37.7061 110.745 38.2361C110.61 41.129 110.431 48.2353 108.499 50.1489C106.424 52.1882 103.953 53.3561 104.312 56.797L110.089 85.6624L123.179 84.2789L123.143 57.8661C123.143 50.7598 115.983 50.9394 115.003 47.1213V47.1302Z"
        fill="#F9D7B5"
      />
      <path
        d="M129.207 100.881C117.51 104.385 109.613 104.528 107.349 104.295C106.109 104.16 107.232 95.0774 105.759 82.5807C104.492 71.8179 102.156 58.2521 104.168 54.416C105.238 52.3856 107.996 50.2923 108.112 50.3552C108.112 50.3552 115.03 52.1969 116.755 50.6607C116.989 50.4541 117.096 50.0408 116.387 49.4209C118.983 50.4091 121.975 52.0712 122.936 55.0089C127.841 70.1289 131.534 100.18 129.216 100.872L129.207 100.881Z"
        fill="#009500"
      />
      <path
        d="M109.485 61.4776C112.027 61.1182 113.806 58.7644 113.447 56.2219C113.087 53.6795 110.733 51.9096 108.182 52.269C105.639 52.6284 103.861 54.9821 104.22 57.5246C104.579 60.0671 106.933 61.8369 109.485 61.4776Z"
        fill="#009500"
      />
      <path
        d="M104.76 64.3975C102.9 62.7445 101.867 53.4191 105.991 54.4253C110.114 55.4405 125.001 61.3699 125.001 61.3699L129.331 69.9945C121.111 70.839 109.36 68.4852 104.76 64.3885V64.3975Z"
        fill="#009500"
      />
      <mask
        id="mask1_26570_10091"
        fill="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="116"
        y="23"
        width="26"
        height="16"
      >
        <path d="M138.582 23L116 27.1797L118.481 39L141.063 34.8202L138.582 23Z" fill="white" />
      </mask>
      <g mask="url(#mask1_26570_10091)">
        <path
          d="M121.269 30.2954C120.686 30.4742 120.639 31.8377 121.162 33.3464C121.686 34.8552 122.59 35.9169 123.186 35.7269L128.351 34.8776L125.947 28.0938L121.258 30.3066L121.269 30.2954Z"
          fill="#4D4D4D"
        />
        <path
          d="M124.636 27.7478C123.755 28.0161 123.684 30.0724 124.469 32.3188C125.267 34.5652 126.624 36.1745 127.504 35.8951L139.262 33.0005L135.906 23.501L124.636 27.7478Z"
          fill="#828282"
        />
        <path
          d="M135.907 23.5006C135.443 23.6459 135.169 24.2159 135.098 25.0541C135.217 24.6741 135.407 24.417 135.681 24.3276C136.561 24.0594 137.93 25.6464 138.716 27.9039C139.501 30.1503 139.441 32.1955 138.561 32.4749C138.287 32.5643 137.966 32.4749 137.633 32.2179C138.216 32.8437 138.799 33.1455 139.263 33.0002C140.298 32.6872 140.37 30.2956 139.453 27.6804C138.537 25.0652 136.942 23.1989 135.907 23.5118V23.5006Z"
          fill="#686868"
        />
        <path
          d="M138.546 32.464C139.426 32.1957 139.498 30.1394 138.712 27.893C137.915 25.6466 136.558 24.0373 135.677 24.3167C135.404 24.4061 135.201 24.652 135.094 25.0431C135.011 26.0378 135.213 27.3901 135.713 28.8206C136.225 30.2511 136.915 31.4581 137.629 32.2069C137.974 32.4528 138.284 32.5534 138.558 32.464H138.546Z"
          fill="#4DC4FF"
        />
        <path
          d="M117.888 32.3521C117.304 32.5309 117.257 33.8943 117.781 35.4031C118.304 36.9118 119.209 37.9736 119.804 37.7836L124.969 36.9342L122.565 30.1504L117.888 32.3521Z"
          fill="#333333"
        />
        <path
          d="M121.251 29.8035C120.371 30.0717 120.299 32.1281 121.085 34.3745C121.882 36.6208 123.239 38.2302 124.119 37.9508L135.878 35.0562L132.522 25.5566L121.251 29.8035Z"
          fill="#828282"
        />
        <path
          d="M132.527 25.5564C132.063 25.7017 131.789 26.2717 131.718 27.1099C131.837 26.7299 132.027 26.4729 132.301 26.3835C133.182 26.1152 134.55 27.7022 135.336 29.9598C136.121 32.2173 136.062 34.2513 135.181 34.5307C134.907 34.6201 134.586 34.5307 134.253 34.2737C134.836 34.8995 135.419 35.2013 135.883 35.056C136.919 34.7431 136.99 32.3514 136.074 29.7362C135.157 27.1099 133.562 25.2547 132.539 25.5676L132.527 25.5564Z"
          fill="#686868"
        />
        <path
          d="M135.182 34.5196C136.062 34.2514 136.134 32.195 135.336 29.9487C134.539 27.7023 133.182 26.0929 132.302 26.3723C132.028 26.4618 131.825 26.7076 131.718 27.0988C131.635 28.0934 131.837 29.4457 132.337 30.8763C132.849 32.3068 133.539 33.5138 134.241 34.2626C134.587 34.5084 134.896 34.609 135.17 34.5196H135.182Z"
          fill="#4DC4FF"
        />
        <path
          d="M137.764 25.9004C138.117 26.4624 138.448 27.1412 138.715 27.8926C139.5 30.1389 139.429 32.1956 138.548 32.4639H138.56C138.286 32.5531 137.977 32.4526 137.632 32.207C137.115 31.6653 136.612 30.8828 136.179 29.9502L137.764 25.9004Z"
          fill="#AEE4FF"
        />
        <path
          d="M135.695 31.1992C136.075 32.9131 135.893 34.3033 135.18 34.5205H135.168C134.95 34.5917 134.709 34.5405 134.445 34.3926L135.695 31.1992Z"
          fill="#AEE4FF"
        />
      </g>
      <path
        d="M123.134 35.9535C124.095 37.4897 125.254 37.912 125.326 38.9182L127.985 38.7115C127.932 37.9389 130.303 37.0855 129.594 31.9915C129.342 30.069 129.108 27.248 127.68 27.7242C127.357 27.8499 127.384 28.2902 127.384 28.2902C127.33 28.1913 127.15 27.7332 126.593 27.9038C126.225 28.0117 126.18 28.2812 126.207 28.5148C126.162 28.3441 125.865 28.0566 125.389 28.1824C124.913 28.3081 124.895 28.7124 124.913 28.8831C124.437 28.6315 123.709 28.7573 123.628 29.6018C123.547 30.4373 123.835 31.722 123.871 32.5575C123.763 32.0724 123.682 31.5873 123.628 31.0932C123.502 29.9612 122.146 30.1139 122.128 30.9404C122.155 31.5513 122.101 34.1747 123.152 35.9265L123.134 35.9535Z"
        fill="#F9D7B5"
      />
      <path
        d="M128.02 38.7026C128.128 37.9569 127.598 37.2651 126.834 37.1663C126.079 37.0675 125.379 37.5886 125.271 38.3342C125.163 39.0799 125.693 39.7717 126.457 39.8705C127.211 39.9693 127.912 39.4482 128.02 38.7026Z"
        fill="#F9D7B5"
      />
      <path
        d="M130.959 64.6658L124.392 64.9173L125.326 38.5404L128.048 38.4326L130.968 64.6568L130.959 64.6658Z"
        fill="#F9D7B5"
      />
      <path
        d="M125.227 39.8705C124.248 39.6459 123.915 61.5488 124.077 65.2233C124.203 65.8072 131.309 75.7704 131.103 65.0885C130.977 58.4404 129.243 40.2209 128.551 39.7268C127.85 39.2417 126.206 40.0951 125.227 39.8795V39.8705Z"
        fill="#009500"
      />
      <path
        d="M121.613 30.4644C120.832 26.2599 115.684 23.3221 111.641 23.1784C107.536 23.0346 102.927 24.9662 101.202 28.7844C99.7554 31.9827 99.7554 36.1871 101.57 39.089C104.76 44.1829 109.871 44.5153 109.862 44.5332L110.204 39.3675C110.896 39.1339 109.898 35.9715 110.869 36.0254C112.782 36.1243 115.289 35.9805 117.077 35.5223C118.64 35.127 120.41 34.3095 121.263 32.7822C121.362 32.6025 121.443 32.4229 121.506 32.2342C121.694 31.6682 121.721 31.0663 121.613 30.4733V30.4644Z"
        fill="#4D4D4D"
      />
    </svg>
  );
};

export default NoReviewsIllustration;
